module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/envelope-container-popup-1O5mAb5n.html";